var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table" }, [
    _c("table", [
      _c("thead", [
        _c(
          "tr",
          [
            _vm._l(_vm.headers, function (ref, index) {
              var labelKey = ref.labelKey
              return _c("th", { key: index }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("table.header." + labelKey)) +
                    "\n        "
                ),
              ])
            }),
            _vm._v(" "),
            _vm.hasUpdateTrRepAccess ? _c("th") : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.accounts, function (user, index) {
          return _c(
            "tr",
            { key: user.id },
            [
              _vm._l(_vm.headers, function (ref) {
                var valueKey = ref.valueKey
                return _c("td", { key: valueKey + "_" + index }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("isEmptyValue")(user[valueKey])) +
                      "\n        "
                  ),
                ])
              }),
              _vm._v(" "),
              _vm.hasUpdateTrRepAccess
                ? _c(
                    "td",
                    [
                      _c("HKLButton", {
                        attrs: { color: "orange", action: "invite" },
                        on: {
                          click: function () {
                            return _vm.inviteUser(user.accountId)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }